import React from 'react';
import { getChannelFromEpg } from 'containers/NewSearchPage/utils/getChannelFromEpg';
import { getCurrentEvent } from '../components/DetailsCard/utls/getCurrentEvent';

export const useGetEventFromEpg = ({ contentInfo }) => {
  let eventFromEpg = '';
  const groudId = contentInfo?.channel_group_id || contentInfo?.id;
  const channelFromEpg = getChannelFromEpg(groudId);
  if (contentInfo?.content_type === 'E') {
    eventFromEpg = channelFromEpg?.events?.find(
      event =>
        event?.unix_begin === contentInfo?.unix_begin &&
        event?.unix_end === contentInfo?.unix_end,
    );
  } else {
    eventFromEpg = getCurrentEvent(contentInfo?.content_type, groudId);
  }
  return { eventFromEpg, channelFromEpg };
};
